export default {
  SET_CONTRACTS(state, data) {
    state.contracts = data
  },
  SET_CONTRACTS_V2(state, data) {
    state.contractList = data
    // state.contractListCount = data.count
  },
  SET_ONE_CONTRACT(state, data) {
    state.single_contract = data
  },
  SET_CONTRACT_HISTORY(state, data) {
    state.contract_history = data
  },
  SET_CONTRACT_TEMPLATES(state, data) {
    state.contract_templates = data
  },
  SET_CONTRACT_TEMPLATES_FILE(state, data) {
    state.contract_templates_file = data
  },
  SET_ONE_CONTRACT_TEMPLATE(state, data) {
    state.single_contract_template = data
  },
  SET_ONE_CONTRACT_TEMPLATE_FILE(state, data) {
    state.single_contract_template_file = data
  },
  SET_CONTRACT_TEMPLATE_FIELDS(state, data) {
    state.contract_template_fields = data
  },
}